
import * as ipxRuntime$gEhy41T2DT from '/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$gEhy41T2DT, defaults: {"maxAge":604800} }
}
        